export function Footer() {
  return (
    <footer className="titan-footer">
      <p>&copy; {new Date().getFullYear()} CyberDudeBivash Pvt. Ltd.</p>
    </footer>
  );
}
